var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMalaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 136,
    viewBox: "0 0 144 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.494 22.8299L103.231 22.8299C100.97 9.8733 89.645 0 76.048 0L67.4064 0C53.8093 0 42.484 9.88443 40.2233 22.8299L27.5171 22.8299C12.3499 22.8299 0 35.1743 0 50.3461L0 108.495C0 123.667 12.3499 136 27.5171 136L116.483 136C131.661 136 144 123.656 144 108.495L144 50.3461C144 35.1743 131.65 22.8411 116.483 22.8411L116.494 22.8299ZM67.4064 10.0514L76.048 10.0514C83.9768 10.0514 90.703 15.3387 92.8633 22.5739L50.591 22.5739C52.7625 15.3387 59.4775 10.0514 67.4064 10.0514ZM93.3979 32.9036L93.3979 125.915L50.0565 125.915L50.0565 32.9036L93.3979 32.9036ZM10.0781 108.484L10.0781 50.3349C10.0781 40.7176 17.9067 32.9036 27.5171 32.9036L39.5997 32.9036L39.5997 125.915L27.5171 125.915C17.9067 125.915 10.0781 118.09 10.0781 108.484ZM133.933 108.484C133.933 118.101 126.104 125.915 116.494 125.915H103.855L103.855 32.9036L116.494 32.9036C126.116 32.9036 133.933 40.7288 133.933 50.3349L133.933 108.484Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaIcon);
export default __webpack_public_path__ + "static/media/mala-icon.1d166ba2a72a3eca38fe121c8c7e482f.svg";
export { ForwardRef as ReactComponent };